import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';
import useMediaQueries from '../hooks/media-query-hooks';
import PatientsTable from './doctor-patients-page/PatientsTable';
import DoctorPendingInvitations from './doctor-patients-page/DoctorPendingInvitations';

const useStyles = makeStyles((_theme) => {
  return {
    titleCta: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  };
});

const DoctorPatientsPage = (props) => {
  const { title } = props;
  const classes = useStyles();

  const { isMd } = useMediaQueries();

  return (
    <Grid container spacing={ isMd ? 4 : 2 }>
      <Grid item xs={ 12 }>
        <div className={ classes.titleCta }>
          <Typography variant='h6' color='textPrimary'>
            {title}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={ 12 }>
        <Divider />
      </Grid>
      <Grid container item xs={ 12 }>
        <Grid item xs={ 12 }>
          <DoctorPendingInvitations />
        </Grid>
        <Grid item xs={ 12 }>
          <PatientsTable />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DoctorPatientsPage;
